export type PeopleTranslations = {
  title: string;
  subtitle: string;
  add_person: string;
  search_placeholder: string;
  table_name: string;
  table_type: string;
  table_status: string;
  table_notes: string;
  table_loading: string;
  table_empty: string;
  status_active: string;
  status_inactive: string;
  type_partner: string;
  type_employee: string;
  type_external: string;
  type_none: string;
  add_title: string;
  add_description: string;
  edit_title: string;
  edit_description: string;
  name_label: string;
  email_label: string;
  email_placeholder: string;
  type_label: string;
  status_label: string;
  notes_label: string;
  notes_placeholder: string;
  type_placeholder: string;
  cancel: string;
  save: string;
  saving: string;
  delete_title: string;
  delete_description_named: string;
  delete_description_default: string;
  delete_confirm: string;
  deleting: string;
  action_edit: string;
  action_delete: string;
  toast_name_required: string;
  toast_load_failed: string;
  toast_save_failed: string;
  toast_save_timeout: string;
  toast_add_success: string;
  toast_update_success: string;
  toast_delete_failed: string;
  toast_delete_success: string;
};

export const peopleTranslations: Record<string, PeopleTranslations> = {
  pt: {
    title: "Pessoas",
    subtitle: "Pessoas que podem ser associadas a despesas da empresa para dar contexto humano.",
    add_person: "Adicionar pessoa",
    search_placeholder: "Pesquisar pessoas...",
    table_name: "Nome",
    table_type: "Tipo",
    table_status: "Estado",
    table_notes: "Notas",
    table_loading: "A carregar pessoas...",
    table_empty: "Nenhuma pessoa encontrada.",
    status_active: "Ativo",
    status_inactive: "Inativo",
    type_partner: "Sócio",
    type_employee: "Colaborador",
    type_external: "Externo",
    type_none: "Nenhum",
    add_title: "Adicionar pessoa",
    add_description: "Crie uma pessoa para atribuir despesas a um indivíduo real.",
    edit_title: "Editar pessoa",
    edit_description: "Atualize os detalhes da pessoa ou marque como inativa.",
    name_label: "Nome",
    email_label: "Email",
    email_placeholder: "Opcional",
    type_label: "Tipo",
    status_label: "Estado",
    notes_label: "Notas",
    notes_placeholder: "Notas opcionais",
    type_placeholder: "Opcional",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "A guardar...",
    delete_title: "Eliminar pessoa?",
    delete_description_named: "Isto irá remover {{name}} permanentemente e limpar associações.",
    delete_description_default: "Esta ação não pode ser desfeita.",
    delete_confirm: "Eliminar",
    deleting: "A eliminar...",
    action_edit: "Editar",
    action_delete: "Eliminar",
    toast_name_required: "O nome é obrigatório.",
    toast_load_failed: "Não foi possível carregar as pessoas.",
    toast_save_failed: "Não foi possível guardar a pessoa.",
    toast_save_timeout: "O pedido demorou demasiado. Tente novamente.",
    toast_add_success: "Pessoa adicionada.",
    toast_update_success: "Pessoa atualizada.",
    toast_delete_failed: "Não foi possível eliminar a pessoa.",
    toast_delete_success: "Pessoa eliminada.",
  },
  en: {
    title: "People",
    subtitle: "People that can be associated with company expenses to provide human context.",
    add_person: "Add person",
    search_placeholder: "Search people...",
    table_name: "Name",
    table_type: "Type",
    table_status: "Status",
    table_notes: "Notes",
    table_loading: "Loading people...",
    table_empty: "No people found.",
    status_active: "Active",
    status_inactive: "Inactive",
    type_partner: "Partner",
    type_employee: "Employee",
    type_external: "External",
    type_none: "None",
    add_title: "Add person",
    add_description: "Create a person to attribute expenses to a real individual.",
    edit_title: "Edit person",
    edit_description: "Update the person details or set them as inactive.",
    name_label: "Name",
    email_label: "Email",
    email_placeholder: "Optional",
    type_label: "Type",
    status_label: "Status",
    notes_label: "Notes",
    notes_placeholder: "Optional notes",
    type_placeholder: "Optional",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    delete_title: "Delete person?",
    delete_description_named: "This will permanently remove {{name}} and clear any associations.",
    delete_description_default: "This action cannot be undone.",
    delete_confirm: "Delete",
    deleting: "Deleting...",
    action_edit: "Edit",
    action_delete: "Delete",
    toast_name_required: "Name is required.",
    toast_load_failed: "Failed to load people.",
    toast_save_failed: "Failed to save person.",
    toast_save_timeout: "Request timed out. Please try again.",
    toast_add_success: "Person added.",
    toast_update_success: "Person updated.",
    toast_delete_failed: "Failed to delete person.",
    toast_delete_success: "Person deleted.",
  },
  es: {
    title: "Personas",
    subtitle: "Personas que pueden asociarse a los gastos de la empresa para aportar contexto humano.",
    add_person: "Añadir persona",
    search_placeholder: "Buscar personas...",
    table_name: "Nombre",
    table_type: "Tipo",
    table_status: "Estado",
    table_notes: "Notas",
    table_loading: "Cargando personas...",
    table_empty: "No se encontraron personas.",
    status_active: "Activo",
    status_inactive: "Inactivo",
    type_partner: "Socio",
    type_employee: "Empleado",
    type_external: "Externo",
    type_none: "Ninguno",
    add_title: "Añadir persona",
    add_description: "Crea una persona para atribuir gastos a un individuo real.",
    edit_title: "Editar persona",
    edit_description: "Actualiza los detalles de la persona o márcala como inactiva.",
    name_label: "Nombre",
    email_label: "Email",
    email_placeholder: "Opcional",
    type_label: "Tipo",
    status_label: "Estado",
    notes_label: "Notas",
    notes_placeholder: "Notas opcionales",
    type_placeholder: "Opcional",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "Guardando...",
    delete_title: "¿Eliminar persona?",
    delete_description_named: "Esto eliminará a {{name}} de forma permanente y limpiará las asociaciones.",
    delete_description_default: "Esta acción no se puede deshacer.",
    delete_confirm: "Eliminar",
    deleting: "Eliminando...",
    action_edit: "Editar",
    action_delete: "Eliminar",
    toast_name_required: "El nombre es obligatorio.",
    toast_load_failed: "No se pudieron cargar las personas.",
    toast_save_failed: "No se pudo guardar la persona.",
    toast_save_timeout: "La solicitud tardó demasiado. Inténtalo de nuevo.",
    toast_add_success: "Persona añadida.",
    toast_update_success: "Persona actualizada.",
    toast_delete_failed: "No se pudo eliminar la persona.",
    toast_delete_success: "Persona eliminada.",
  },
  et: {
    title: "Inimesed",
    subtitle: "Inimesed, keda saab seostada ettevõtte kuludega, et anda inimlikku konteksti.",
    add_person: "Lisa inimene",
    search_placeholder: "Otsi inimesi...",
    table_name: "Nimi",
    table_type: "Tüüp",
    table_status: "Staatus",
    table_notes: "Märkused",
    table_loading: "Inimesi laaditakse...",
    table_empty: "Inimesi ei leitud.",
    status_active: "Aktiivne",
    status_inactive: "Mitteaktiivne",
    type_partner: "Partner",
    type_employee: "Töötaja",
    type_external: "Väline",
    type_none: "Puudub",
    add_title: "Lisa inimene",
    add_description: "Loo inimene, et seostada kulusid reaalse isikuga.",
    edit_title: "Muuda inimest",
    edit_description: "Uuenda inimese andmeid või märgi mitteaktiivseks.",
    name_label: "Nimi",
    email_label: "E-post",
    email_placeholder: "Valikuline",
    type_label: "Tüüp",
    status_label: "Staatus",
    notes_label: "Märkused",
    notes_placeholder: "Valikulised märkused",
    type_placeholder: "Valikuline",
    cancel: "Tühista",
    save: "Salvesta",
    saving: "Salvestamine...",
    delete_title: "Kustutada inimene?",
    delete_description_named: "See eemaldab {{name}} jäädavalt ja puhastab seosed.",
    delete_description_default: "Seda toimingut ei saa tagasi võtta.",
    delete_confirm: "Kustuta",
    deleting: "Kustutamine...",
    action_edit: "Muuda",
    action_delete: "Kustuta",
    toast_name_required: "Nimi on kohustuslik.",
    toast_load_failed: "Inimesi ei õnnestunud laadida.",
    toast_save_failed: "Inimest ei õnnestunud salvestada.",
    toast_save_timeout: "Päring võttis liiga kaua aega. Proovi uuesti.",
    toast_add_success: "Inimene lisatud.",
    toast_update_success: "Inimene uuendatud.",
    toast_delete_failed: "Inimest ei õnnestunud kustutada.",
    toast_delete_success: "Inimene kustutatud.",
  },
  de: {
    title: "Personen",
    subtitle: "Personen, die Unternehmensausgaben zugeordnet werden können, um menschlichen Kontext zu geben.",
    add_person: "Person hinzufügen",
    search_placeholder: "Personen suchen...",
    table_name: "Name",
    table_type: "Typ",
    table_status: "Status",
    table_notes: "Notizen",
    table_loading: "Personen werden geladen...",
    table_empty: "Keine Personen gefunden.",
    status_active: "Aktiv",
    status_inactive: "Inaktiv",
    type_partner: "Partner",
    type_employee: "Mitarbeiter",
    type_external: "Extern",
    type_none: "Keine",
    add_title: "Person hinzufügen",
    add_description: "Erstellen Sie eine Person, um Ausgaben einer realen Person zuzuordnen.",
    edit_title: "Person bearbeiten",
    edit_description: "Aktualisieren Sie die Personendaten oder setzen Sie sie auf inaktiv.",
    name_label: "Name",
    email_label: "E-Mail",
    email_placeholder: "Optional",
    type_label: "Typ",
    status_label: "Status",
    notes_label: "Notizen",
    notes_placeholder: "Optionale Notizen",
    type_placeholder: "Optional",
    cancel: "Abbrechen",
    save: "Speichern",
    saving: "Speichern...",
    delete_title: "Person löschen?",
    delete_description_named: "Dadurch wird {{name}} dauerhaft entfernt und Zuordnungen werden gelöscht.",
    delete_description_default: "Diese Aktion kann nicht rückgängig gemacht werden.",
    delete_confirm: "Löschen",
    deleting: "Löschen...",
    action_edit: "Bearbeiten",
    action_delete: "Löschen",
    toast_name_required: "Name ist erforderlich.",
    toast_load_failed: "Personen konnten nicht geladen werden.",
    toast_save_failed: "Person konnte nicht gespeichert werden.",
    toast_save_timeout: "Die Anfrage hat zu lange gedauert. Bitte erneut versuchen.",
    toast_add_success: "Person hinzugefügt.",
    toast_update_success: "Person aktualisiert.",
    toast_delete_failed: "Person konnte nicht gelöscht werden.",
    toast_delete_success: "Person gelöscht.",
  },
  fr: {
    title: "Personnes",
    subtitle: "Personnes pouvant être associées aux dépenses de l’entreprise pour apporter un contexte humain.",
    add_person: "Ajouter une personne",
    search_placeholder: "Rechercher des personnes...",
    table_name: "Nom",
    table_type: "Type",
    table_status: "Statut",
    table_notes: "Notes",
    table_loading: "Chargement des personnes...",
    table_empty: "Aucune personne trouvée.",
    status_active: "Actif",
    status_inactive: "Inactif",
    type_partner: "Associé",
    type_employee: "Employé",
    type_external: "Externe",
    type_none: "Aucun",
    add_title: "Ajouter une personne",
    add_description: "Créez une personne pour attribuer des dépenses à un individu réel.",
    edit_title: "Modifier la personne",
    edit_description: "Mettez à jour les informations ou passez-la en inactive.",
    name_label: "Nom",
    email_label: "Email",
    email_placeholder: "Facultatif",
    type_label: "Type",
    status_label: "Statut",
    notes_label: "Notes",
    notes_placeholder: "Notes facultatives",
    type_placeholder: "Facultatif",
    cancel: "Annuler",
    save: "Enregistrer",
    saving: "Enregistrement...",
    delete_title: "Supprimer la personne ?",
    delete_description_named: "Cela supprimera définitivement {{name}} et effacera les associations.",
    delete_description_default: "Cette action est irréversible.",
    delete_confirm: "Supprimer",
    deleting: "Suppression...",
    action_edit: "Modifier",
    action_delete: "Supprimer",
    toast_name_required: "Le nom est obligatoire.",
    toast_load_failed: "Impossible de charger les personnes.",
    toast_save_failed: "Impossible d’enregistrer la personne.",
    toast_save_timeout: "La requête a expiré. Réessayez.",
    toast_add_success: "Personne ajoutée.",
    toast_update_success: "Personne mise à jour.",
    toast_delete_failed: "Impossible de supprimer la personne.",
    toast_delete_success: "Personne supprimée.",
  },
  it: {
    title: "Persone",
    subtitle: "Persone che possono essere associate alle spese aziendali per fornire contesto umano.",
    add_person: "Aggiungi persona",
    search_placeholder: "Cerca persone...",
    table_name: "Nome",
    table_type: "Tipo",
    table_status: "Stato",
    table_notes: "Note",
    table_loading: "Caricamento persone...",
    table_empty: "Nessuna persona trovata.",
    status_active: "Attivo",
    status_inactive: "Inattivo",
    type_partner: "Partner",
    type_employee: "Dipendente",
    type_external: "Esterno",
    type_none: "Nessuno",
    add_title: "Aggiungi persona",
    add_description: "Crea una persona per attribuire le spese a un individuo reale.",
    edit_title: "Modifica persona",
    edit_description: "Aggiorna i dettagli della persona o impostala come inattiva.",
    name_label: "Nome",
    email_label: "Email",
    email_placeholder: "Opzionale",
    type_label: "Tipo",
    status_label: "Stato",
    notes_label: "Note",
    notes_placeholder: "Note facoltative",
    type_placeholder: "Opzionale",
    cancel: "Annulla",
    save: "Salva",
    saving: "Salvataggio...",
    delete_title: "Eliminare la persona?",
    delete_description_named: "Questo rimuoverà definitivamente {{name}} e cancellerà le associazioni.",
    delete_description_default: "Questa azione non può essere annullata.",
    delete_confirm: "Elimina",
    deleting: "Eliminazione...",
    action_edit: "Modifica",
    action_delete: "Elimina",
    toast_name_required: "Il nome è obbligatorio.",
    toast_load_failed: "Impossibile caricare le persone.",
    toast_save_failed: "Impossibile salvare la persona.",
    toast_save_timeout: "La richiesta è scaduta. Riprova.",
    toast_add_success: "Persona aggiunta.",
    toast_update_success: "Persona aggiornata.",
    toast_delete_failed: "Impossibile eliminare la persona.",
    toast_delete_success: "Persona eliminata.",
  },
  nl: {
    title: "Personen",
    subtitle: "Personen die aan bedrijfsuitgaven kunnen worden gekoppeld om menselijke context te geven.",
    add_person: "Persoon toevoegen",
    search_placeholder: "Personen zoeken...",
    table_name: "Naam",
    table_type: "Type",
    table_status: "Status",
    table_notes: "Notities",
    table_loading: "Personen laden...",
    table_empty: "Geen personen gevonden.",
    status_active: "Actief",
    status_inactive: "Inactief",
    type_partner: "Partner",
    type_employee: "Werknemer",
    type_external: "Extern",
    type_none: "Geen",
    add_title: "Persoon toevoegen",
    add_description: "Maak een persoon aan om uitgaven aan een echt persoon toe te wijzen.",
    edit_title: "Persoon bewerken",
    edit_description: "Werk de gegevens bij of zet op inactief.",
    name_label: "Naam",
    email_label: "E-mail",
    email_placeholder: "Optioneel",
    type_label: "Type",
    status_label: "Status",
    notes_label: "Notities",
    notes_placeholder: "Optionele notities",
    type_placeholder: "Optioneel",
    cancel: "Annuleren",
    save: "Opslaan",
    saving: "Opslaan...",
    delete_title: "Persoon verwijderen?",
    delete_description_named: "Dit verwijdert {{name}} definitief en wist koppelingen.",
    delete_description_default: "Deze actie kan niet ongedaan worden gemaakt.",
    delete_confirm: "Verwijderen",
    deleting: "Verwijderen...",
    action_edit: "Bewerken",
    action_delete: "Verwijderen",
    toast_name_required: "Naam is verplicht.",
    toast_load_failed: "Personen konden niet worden geladen.",
    toast_save_failed: "Persoon kon niet worden opgeslagen.",
    toast_save_timeout: "De aanvraag duurde te lang. Probeer opnieuw.",
    toast_add_success: "Persoon toegevoegd.",
    toast_update_success: "Persoon bijgewerkt.",
    toast_delete_failed: "Persoon kon niet worden verwijderd.",
    toast_delete_success: "Persoon verwijderd.",
  },
  sv: {
    title: "Personer",
    subtitle: "Personer som kan kopplas till företagets utgifter för att ge mänsklig kontext.",
    add_person: "Lägg till person",
    search_placeholder: "Sök personer...",
    table_name: "Namn",
    table_type: "Typ",
    table_status: "Status",
    table_notes: "Anteckningar",
    table_loading: "Laddar personer...",
    table_empty: "Inga personer hittades.",
    status_active: "Aktiv",
    status_inactive: "Inaktiv",
    type_partner: "Partner",
    type_employee: "Anställd",
    type_external: "Extern",
    type_none: "Ingen",
    add_title: "Lägg till person",
    add_description: "Skapa en person för att koppla utgifter till en verklig individ.",
    edit_title: "Redigera person",
    edit_description: "Uppdatera uppgifter eller markera som inaktiv.",
    name_label: "Namn",
    email_label: "E-post",
    email_placeholder: "Valfritt",
    type_label: "Typ",
    status_label: "Status",
    notes_label: "Anteckningar",
    notes_placeholder: "Valfria anteckningar",
    type_placeholder: "Valfritt",
    cancel: "Avbryt",
    save: "Spara",
    saving: "Sparar...",
    delete_title: "Ta bort person?",
    delete_description_named: "Detta tar bort {{name}} permanent och rensar kopplingar.",
    delete_description_default: "Den här åtgärden kan inte ångras.",
    delete_confirm: "Ta bort",
    deleting: "Tar bort...",
    action_edit: "Redigera",
    action_delete: "Ta bort",
    toast_name_required: "Namn krävs.",
    toast_load_failed: "Kunde inte ladda personer.",
    toast_save_failed: "Kunde inte spara personen.",
    toast_save_timeout: "Begäran tog för lång tid. Försök igen.",
    toast_add_success: "Person tillagd.",
    toast_update_success: "Person uppdaterad.",
    toast_delete_failed: "Kunde inte ta bort personen.",
    toast_delete_success: "Person borttagen.",
  },
  da: {
    title: "Personer",
    subtitle: "Personer, der kan knyttes til virksomhedens udgifter for at give menneskelig kontekst.",
    add_person: "Tilføj person",
    search_placeholder: "Søg personer...",
    table_name: "Navn",
    table_type: "Type",
    table_status: "Status",
    table_notes: "Noter",
    table_loading: "Indlæser personer...",
    table_empty: "Ingen personer fundet.",
    status_active: "Aktiv",
    status_inactive: "Inaktiv",
    type_partner: "Partner",
    type_employee: "Medarbejder",
    type_external: "Ekstern",
    type_none: "Ingen",
    add_title: "Tilføj person",
    add_description: "Opret en person for at knytte udgifter til en reel person.",
    edit_title: "Rediger person",
    edit_description: "Opdater personens oplysninger eller gør dem inaktive.",
    name_label: "Navn",
    email_label: "E-mail",
    email_placeholder: "Valgfri",
    type_label: "Type",
    status_label: "Status",
    notes_label: "Noter",
    notes_placeholder: "Valgfrie noter",
    type_placeholder: "Valgfri",
    cancel: "Annuller",
    save: "Gem",
    saving: "Gemmer...",
    delete_title: "Slet person?",
    delete_description_named: "Dette fjerner {{name}} permanent og rydder associationer.",
    delete_description_default: "Denne handling kan ikke fortrydes.",
    delete_confirm: "Slet",
    deleting: "Sletter...",
    action_edit: "Rediger",
    action_delete: "Slet",
    toast_name_required: "Navn er påkrævet.",
    toast_load_failed: "Kunne ikke indlæse personer.",
    toast_save_failed: "Kunne ikke gemme personen.",
    toast_save_timeout: "Anmodningen tog for lang tid. Prøv igen.",
    toast_add_success: "Person tilføjet.",
    toast_update_success: "Person opdateret.",
    toast_delete_failed: "Kunne ikke slette personen.",
    toast_delete_success: "Person slettet.",
  },
  fi: {
    title: "Henkilöt",
    subtitle: "Henkilöt, jotka voidaan liittää yrityksen kuluihin inhimillisen kontekstin antamiseksi.",
    add_person: "Lisää henkilö",
    search_placeholder: "Hae henkilöitä...",
    table_name: "Nimi",
    table_type: "Tyyppi",
    table_status: "Tila",
    table_notes: "Muistiinpanot",
    table_loading: "Ladataan henkilöitä...",
    table_empty: "Henkilöitä ei löytynyt.",
    status_active: "Aktiivinen",
    status_inactive: "Ei aktiivinen",
    type_partner: "Kumppani",
    type_employee: "Työntekijä",
    type_external: "Ulkoinen",
    type_none: "Ei mitään",
    add_title: "Lisää henkilö",
    add_description: "Luo henkilö, jotta kulut voidaan kohdistaa oikealle henkilölle.",
    edit_title: "Muokkaa henkilöä",
    edit_description: "Päivitä henkilön tiedot tai merkitse ei-aktiiviseksi.",
    name_label: "Nimi",
    email_label: "Sähköposti",
    email_placeholder: "Valinnainen",
    type_label: "Tyyppi",
    status_label: "Tila",
    notes_label: "Muistiinpanot",
    notes_placeholder: "Valinnaiset muistiinpanot",
    type_placeholder: "Valinnainen",
    cancel: "Peruuta",
    save: "Tallenna",
    saving: "Tallennetaan...",
    delete_title: "Poista henkilö?",
    delete_description_named: "Tämä poistaa {{name}} pysyvästi ja tyhjentää liitokset.",
    delete_description_default: "Tätä toimintoa ei voi perua.",
    delete_confirm: "Poista",
    deleting: "Poistetaan...",
    action_edit: "Muokkaa",
    action_delete: "Poista",
    toast_name_required: "Nimi on pakollinen.",
    toast_load_failed: "Henkilöitä ei voitu ladata.",
    toast_save_failed: "Henkilöä ei voitu tallentaa.",
    toast_save_timeout: "Pyyntö kesti liian kauan. Yritä uudelleen.",
    toast_add_success: "Henkilö lisätty.",
    toast_update_success: "Henkilö päivitetty.",
    toast_delete_failed: "Henkilöä ei voitu poistaa.",
    toast_delete_success: "Henkilö poistettu.",
  },
};
